import { axios, API } from './config';

export const contractsAPI = {
  getAll: async (eventType = null, status = null) => {
    const params = {};
    if (eventType) params.event_type = eventType;
    if (status) params.status = status;
    const response = await axios.get(`${API}/contracts`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/contracts/${id}`);
    return response.data;
  },
  
  create: async (contractData) => {
    const response = await axios.post(`${API}/contracts`, contractData);
    return response.data;
  },
  
  update: async (id, contractData) => {
    const response = await axios.put(`${API}/contracts/${id}`, contractData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/contracts/${id}`);
    return response.data;
  }
};
